// extracted by mini-css-extract-plugin
export default {"container":"language_switcher_container__VIA2A","profile":"language_switcher_profile__XoxLN"};